import { Box } from '@mui/material'
import { QRCodeSVG } from 'qrcode.react'
import { type ModalProps, QRCodeModalContainer, Typography } from '~sharedUI'

type LinkQRCodeModalProps = {
	link: string | undefined | null
} & ModalProps

export const LinkQRCodeModal = ({ open, onClose, link, ...props }: LinkQRCodeModalProps) => {
	if (!link) return
	return (
		<QRCodeModalContainer
			onClose={onClose}
			open={open}
			fullWidth
			{...props}
		>
			<Box
				sx={{
					padding: '16px  24px 20px',
					display: 'flex',
					flexDirection: 'column',
					gap: '8px'
				}}
			>
				<QRCodeSVG size={422} value={link} />
				<Typography fontSize='md' lineHeight={'40px'} fontWeight='bold' textAlign={'center'}>
					Отсканируйте, чтобы открыть ссылку на своём устройстве
				</Typography>
			</Box>
		</QRCodeModalContainer>
	)
}
